import IconBase from "./IconBase";

const TIcon = props => (
  <IconBase {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 2a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0V4h-5v11.999L13 16a1 1 0 0 1 0 2l-2-.001L9 18v-.001L7 18a1 1 0 0 1 0-2l2-.001V4H4v1a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1h14z"
    />
  </IconBase>
);

export default TIcon;
